query CHATBOT ($message: String!, $sessionId: String, $location: ChatSessionLocation) {
  chatbot (message: $message, sessionId: $sessionId, location: $location) {
    response
    success
    sessionId
    message {
      content
      id
      vote
      createdDatetime
    }
  }
}
